/* eslint-disable no-undef */
import PlayerError from '../../../core/errors/PlayerError';
import { logDebugging, logError } from '../../../log/logger';
import { VAST_TAG, VAST_XML } from '../../../ssp/constants/sspconstants';
import { isIpad } from '../../../utils/browserUtils';
import IMAPlayerListeners from './ima.player.listeners';

export default class IMAPlayerController {
  constructor(playerView, cid) {
    this.idComponent = playerView.idComponent || 0;
    this.playerView = playerView || null;
    this.isfullActivate = false;
    this.cid = cid;
    this.showSkip = false;
    this.autoStart = true;
  }

  load(sspwrapper) {
    this.handler = new IMAPlayerListeners(this.idComponent, this.playerView, this.cid);
    this.idContainerName = `adContainer_ima_${parseInt(Math.random() * 100000, 10)}`;
    this.loadAdDisplayContainer(this.idContainerName);
    this.loadAdRequest(sspwrapper);

    return this.loadAdsLoader();
  }

  loadAdDisplayContainer(idAdContainer) {
    try {
      this.adDisplayContainer = new google.ima.AdDisplayContainer(
        this.playerView.getAdContainer(idAdContainer),
        this.playerView.getPlayerContent(),
      );
      // Must be done as the result of a user action on mobile
      //  if (!BrowserProperties.isMobile() && !BrowserProperties.isSafari()){
      // if (!BrowserProperties.isAutoPlayNotAllowed() || this.fromPlus) {
      this.adDisplayContainer.initialize(); // ESTA LINEA A LO MEJOR HAY QUE DESCOMENTARLA POR EL TEMA DEL PREFETCH
      // }
    } catch (error) {
      logDebugging(error);
      throw error;
    }
  }

  loadAdRequest(sspwrapper) {
    this.adsRequest = new google.ima.AdsRequest();
    if (sspwrapper.type === VAST_XML) {
      this.adsRequest.adsResponse = sspwrapper.xml;
    } else if (sspwrapper.type === VAST_TAG) {
      this.adsRequest.adTagUrl = sspwrapper.tag;
    }

    // SizeConfiguration.setPlayerSize(this.idComponent);

    // // Specify the linear and nonlinear slot sizes. This helps the SDK to
    // // select the correct creative if multiple are returned.
    // this.adsRequest.linearAdSlotWidth = SizeConfiguration.componentWith;
    // this.adsRequest.linearAdSlotHeight = SizeConfiguration.componentHeight;
    // this.adsRequest.nonLinearAdSlotWidth = SizeConfiguration.componentWith;
    // this.adsRequest.nonLinearAdSlotHeight = SizeConfiguration.componentHeight;
    // this.adsRequest.liveStreamPrefetchSeconds = 0;
    // Feature #7941. Override for default VAST load timeout in milliseconds for a single wrapper. The default timeout is 5000ms.
    this.adsRequest.vastLoadTimeout = 8000;
    this.adsRequest.setAdWillAutoPlay(true);
    this.adsRequest.setAdWillPlayMuted(true);
    if (isIpad()) {
      google.ima.settings.setDisableCustomPlaybackForIOS10Plus(true);
    }
  }

  loadAdsLoader() {
    this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer);
    this.adsLoader.requestAds(this.adsRequest);

    return this.activateListenersAdsLoader();
  }

  activateListenersAdsLoader() {
    return new Promise((resolve, reject) => {
      if (this.adsLoader) {
        this.adsLoader.addEventListener(
          google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
          (adsManagerLoadedEvent) => {
            // console.log('google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED');
            const adsRenderingSettings = new google.ima.AdsRenderingSettings();
            // Tell the SDK NOT to save and restore content video state on our behalf.
            adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = false;
            adsRenderingSettings.loadVideoTimeout = 20000;

            this.adsManager = adsManagerLoadedEvent.getAdsManager(
              this.playerView.getPlayerContent(),
              adsRenderingSettings,
            ); // See API reference for contentPlayback
            this.adsManager.addEventListener(
              google.ima.AdErrorEvent.Type.AD_ERROR,
              (adsEvent) => {
                reject(adsEvent.getError()?.data);
              },
              false,
            );
            logDebugging('isCustomPlaybackUsed ', this.adsManager.isCustomPlaybackUsed());
            this.adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, (adEvent) => {
              logDebugging(`[IMAPlayerController] LOADED ${this.cid}`, adEvent.getAd());
              resolve(this);
              // this.dispatchEvent([PlayerEventNames.LOADEDDATA, _this.currentTime, _this.duration]);
            });

            this.adsManager.addEventListener(google.ima.AdEvent.Type.AD_BREAK_READY, () => {
              logDebugging('[IMAPlayerController] AD_BREAK_READY ');
            });
            this.handler.createHandlersAdsManager(this.adsManager);
            try {
              this.initialize();
            } catch (error) {
              reject(error);
            }
          },
          false,
        );
        this.adsLoader.addEventListener(
          google.ima.AdErrorEvent.Type.AD_ERROR,
          (adsEvent) => {
            logDebugging(
              `[IMAPlayerController] ERROR ${adsEvent.getError().toString()} cid ${this.cid}`,
            );
            this.handler.error = adsEvent.getError();
            reject(adsEvent.getError()?.data);
          },
          false,
        );

        this.activateResize();
      } else {
        reject(new Error('[IMAPlayerController] AdsLoader is null'));
      }
    });
  }

  start() {
    this.autoStart = false;
    // this.adDisplayContainer.initialize();
    try {
      // Initialize the ads manager. Ad rules playlist will start at this time.
      // this.adsManager.init(SizeConfiguration.componentWith, SizeConfiguration.componentHeight, google.ima.ViewMode.NORMAL);
      // Call start to show ads. Single video and overlay ads will
      // start at this time; this call will be ignored for ad rules, as ad rules
      // ads start when the adsManager is initialized.
      // this.start();
      if (this.handler.allCompleteSent) {
        this.vpaidDied = true;
        this.handler.sendError(
          'Se ha enviado un complete de la publi y no se puede iniciar el vídeo',
        );
      }
      this.adsManager.start();
    } catch (adError) {
      logError(adError);
      throw Error('no hay publicidad en IMA');
    }
  }

  initialize() {
    this.adDisplayContainer.initialize();
    try {
      // Initialize the ads manager. Ad rules playlist will start at this time.
      this.adsManager.init(
        this.playerView.getPlayerContent().clientWidth,
        this.playerView.getPlayerContent().clientHeight,
        google.ima.ViewMode.NORMAL,
      );
      // Call start to show ads. Single video and overlay ads will
      // start at this time; this call will be ignored for ad rules, as ad rules
      // ads start when the adsManager is initialized.
      // this.start();
      // this.adsManager.start();
    } catch (adError) {
      logError(adError);
      throw Error('no hay publicidad en IMA');
    }
  }

  activateResize() {
    if (this.isfullActivate === false) {
      this.isfullActivate = true;
      window.onresize = () => {
        this.resize();
      };
    }
  }

  remove(throwByError) {
    const delay = throwByError ? 1 : 3000;
    logDebugging('IMAPlayerController.remove');
    this.playerView.remove();
    setTimeout(() => {
      if (this.adDisplayContainer) this.adDisplayContainer.destroy();

      this.handler.remove();
    }, delay);
  }

  pause() {
    if (this.adsManager) this.adsManager.pause();
  }

  resume() {
    if (this.adsManager) this.adsManager.resume();
  }

  getVolume() {
    if (this.adsManager) this.adsManager.getVolume();
  }

  setVolume(level) {
    if (this.adsManager) this.adsManager.setVolume(level);
  }

  mute() {
    if (this.adsManager) this.adsManager.setVolume(0);
  }

  unmute() {
    if (this.adsManager) this.adsManager.setVolume(1);
  }

  getDuration() {
    try {
      return this.handler.duration;
    } catch (error) {
      return null;
    }
  }

  getCurrentTime() {
    try {
      if (this.adsManager) {
        return this.adsManager.getAd().getDuration() - this.adsManager.getRemainingTime();
      }
      return 0;
    } catch (error) {
      return 0;
    }
  }

  skip() {
    if (this.adsManager) {
      if (this.adsManager.getAdSkippableState()) {
        this.adsManager.skip();
      }
    }
  }

  resize() {
    // logDebugging(
    //   'resize en Adsmanager',
    //   this.getContainer().clientWidth,
    //   this.getContainer().clientHeight,
    // );
    if (this.adsManager) {
      // logDebugging('resize en Adsmanager aplico');
      this.adsManager.resize(
        this.getContainer().clientWidth,
        this.getContainer().clientHeight,
        google.ima.ViewMode.NORMAL,
      );
    }
    // } else if (this.adsManager)
    //   this.adsManager.resize(
    //     this.getContainer().clientWidth,
    //     this.getContainer().clientHeight,
    //     google.ima.ViewMode.NORMAL,
    //   );
  }

  getEvent() {
    try {
      return this.handler.IMAPlayerEvent;
    } catch (error) {
      throw new PlayerError('[IMAPlayerController] No se han podido capturar los eventos');
    }
  }

  getContainer() {
    return document.getElementById(this.idComponent).querySelector('#video-ext-container');
  }
}
